import styled, { css } from 'styled-components'
import { Text, Box } from 'rebass'
import { themeGet, fontSize } from 'styled-system'

const linkCss = ({ link }) =>
  link &&
  css`
    color: ${themeGet('colors.font.link')};
    &:hover {
      cursor: pointer;
    }
  `

export const Container = styled(Text).attrs({
  lineHeight: '1.41em',
})`
  ${(props) =>
    props.ellipsis &&
    css`
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    `};

  ${linkCss};

  ${fontSize};
`

export const Mark = styled(Box).attrs({ as: 'mark' })`
  background-color: ${themeGet('colors.secondaryActive')};
  color: ${themeGet('colors.dodgerBlue')};
`
